import {css, Theme} from "@emotion/react";

import {borderRadius, mb} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";

interface IProps {
    className?: string;
    seo_description: string;
}

export const OfferListSeoDescription = (props: IProps) => {
    return <div css={[offerListDescriptionHolder, mb(4)]} className={props.className} dangerouslySetInnerHTML={{__html: `${props.seo_description}`}} />;
};

export const offerListDescriptionHolder = (theme: Theme) => css`
    background-color: #fff;
    padding: 2.4rem;
    ${borderRadius(1)};

    p {
        margin-top: 0;

        &:last-of-type {
            margin-bottom: 0;
        }
    }

    h2 {
        ${getTextVariantStyleFor("headline_5")(theme)};
    }

    h2:first-of-type {
        margin-top: 0;
    }

    a:not(.custom-add-text-box__container) {
        text-decoration: underline;
        text-decoration-color: #ebff00;
        text-decoration-thickness: 5px;
        text-underline-offset: 0.1em;
        text-decoration-skip-ink: none;
    }
`;
import {css, Theme} from "@emotion/react";

import {borderRadius, mb} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";

interface IProps {
    className?: string;
    seo_description: string;
}

export const OfferListSeoDescription = (props: IProps) => {
    return <div css={[offerListDescriptionHolder, mb(4)]} className={props.className} dangerouslySetInnerHTML={{__html: `${props.seo_description}`}} />;
};

export const offerListDescriptionHolder = (theme: Theme) => css`
    background-color: #fff;
    padding: 2.4rem;
    ${borderRadius(1)};

    p {
        margin-top: 0;

        &:last-of-type {
            margin-bottom: 0;
        }
    }

    h2 {
        ${getTextVariantStyleFor("headline_5")(theme)};
    }

    h2:first-of-type {
        margin-top: 0;
    }

    a:not(.custom-add-text-box__container) {
        text-decoration: underline;
        text-decoration-color: #ebff00;
        text-decoration-thickness: 5px;
        text-underline-offset: 0.1em;
        text-decoration-skip-ink: none;
    }
`;
